<template>
  <div class="admin">
    <el-container>
      <el-header height="60px">
        <h2>管理后台</h2>
        <p>管理员可在此管理分类和工具</p>
      </el-header>
      <el-main>
        <el-tabs v-model="activeTab">
          <el-tab-pane label="分类管理" name="categories">
            <el-button type="primary" @click="openCategoryDialog(null)">添加分类</el-button>
            <el-table ref="categoryTableRef" :data="categoryList" row-key="id" style="width: 100%; margin-top: 20px;">
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column label="排序" width="70" align="center">
                <template #default>
                  <el-icon class="drag-handle"><Rank /></el-icon>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" />
              <el-table-column prop="description" label="描述" />
              <el-table-column prop="tool_count" label="工具数" />
              <el-table-column label="操作" width="200">
                <template #default="scope">
                  <el-button size="small" @click="openCategoryDialog(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="deleteCategory(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="工具管理" name="tools">
            <el-button type="primary" @click="openToolDialog(null)">添加工具</el-button>
            <el-table ref="toolTableRef" :data="toolList" row-key="id" style="width: 100%; margin-top: 20px;">
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column label="排序" width="70" align="center">
                <template #default>
                  <el-icon class="drag-handle"><Rank /></el-icon>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" />
              <el-table-column prop="category_name" label="分类" />
              <el-table-column label="类型" width="100">
                <template #default="scope">
                  <el-tag :type="scope.row.tool_type === 'external' ? 'warning' : 'success'">
                    {{ scope.row.tool_type === 'external' ? '外链' : '自建' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="外链地址" />
              <el-table-column label="操作" width="200">
                <template #default="scope">
                  <el-button size="small" @click="openToolDialog(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="deleteTool(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="统计" name="stats">
            <el-row :gutter="20">
              <el-col :xs="24" :sm="8">
                <el-card>
                  <template #header>
                    <div class="card-header">
                      <span>分类数量</span>
                    </div>
                  </template>
                  <div class="stat-number">{{ stats.category_count || 0 }}</div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-card>
                  <template #header>
                    <div class="card-header">
                      <span>工具总数</span>
                    </div>
                  </template>
                  <div class="stat-number">{{ stats.tool_count || 0 }}</div>
                </el-card>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-card>
                  <template #header>
                    <div class="card-header">
                      <span>外链工具</span>
                    </div>
                  </template>
                  <div class="stat-number">{{ stats.external_count || 0 }}</div>
                </el-card>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="password">
            <el-form :model="passwordForm" label-width="120px" style="max-width: 500px; margin-top: 20px;">
              <el-form-item label="旧密码" required>
                <el-input v-model="passwordForm.oldPassword" type="password" show-password placeholder="请输入旧密码" />
              </el-form-item>
              <el-form-item label="新密码" required>
                <el-input v-model="passwordForm.newPassword" type="password" show-password placeholder="请输入新密码" />
              </el-form-item>
              <el-form-item label="确认新密码" required>
                <el-input v-model="passwordForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitPasswordChange">修改密码</el-button>
                <el-button @click="resetPasswordForm">重置</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="文件部署" name="files">
            <el-upload
              class="upload-demo"
              drag
              multiple
              :show-file-list="false"
              :before-upload="beforeUpload"
              :http-request="handleUploadRequest"
            >
              <el-icon class="el-icon--upload"><UploadFilled /></el-icon>
              <div class="el-upload__text">
                拖拽文件到此处或 <em>点击上传</em>
              </div>
              <template #tip>
                <div class="el-upload__tip">
                  支持上传 HTML、PDF、图片、文本等文件，最大 16 MB。
                </div>
              </template>
            </el-upload>

            <!-- 上传进度队列：直观展示每个文件的上传进度 -->
            <div v-if="uploadQueue.length" class="upload-queue">
              <div class="upload-queue-header">
                <span>上传队列（{{ uploadQueue.length }}）</span>
                <el-button link type="primary" size="small" @click="clearFinishedUploads">
                  清除已完成
                </el-button>
              </div>
              <div v-for="task in uploadQueue" :key="task.uid" class="upload-queue-item">
                <span class="uq-name" :title="task.name">{{ task.name }}</span>
                <el-progress
                  class="uq-progress"
                  :percentage="task.percent"
                  :stroke-width="8"
                  :status="task.status === 'error' ? 'exception' : task.status === 'success' ? 'success' : ''"
                />
                <span class="uq-size">{{ formatFileSize(task.size) }}</span>
                <span class="uq-state" :class="task.status">
                  {{
                    task.status === 'success'
                      ? '已完成'
                      : task.status === 'error'
                        ? task.message || '失败'
                        : task.percent + '%'
                  }}
                </span>
              </div>
            </div>
            <el-table :data="fileList" style="width: 100%; margin-top: 20px;">
              <el-table-column prop="name" label="文件名" />
              <el-table-column prop="size" label="大小">
                <template #default="scope">
                  {{ formatFileSize(scope.row.size) }}
                </template>
              </el-table-column>
              <el-table-column prop="url" label="链接">
                <template #default="scope">
                  <el-link :href="scope.row.url" target="_blank">{{ scope.row.url }}</el-link>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="330" fixed="right">
                <template #default="scope">
                  <el-button size="small" @click="copyLink(scope.row.url)">复制链接</el-button>
                  <el-button size="small" type="primary" plain @click="openQrDialog(scope.row)">二维码</el-button>
                  <el-button size="small" v-if="isEditableFile(scope.row.name)" @click="openEditDialog(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="deleteFile(scope.row.name)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="技术文档" name="docs">
            <el-button type="primary" @click="openDocDialog(null)">上传文档</el-button>
            <el-table ref="docTableRef" :data="docList" row-key="id" style="width: 100%; margin-top: 20px;">
              <el-table-column type="index" label="序号" width="80" />
              <el-table-column label="排序" width="70" align="center">
                <template #default>
                  <el-icon class="drag-handle"><Rank /></el-icon>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题" />
              <el-table-column prop="category" label="分类" />
              <el-table-column prop="is_published" label="状态" width="100">
                <template #default="scope">
                  <el-tag :type="scope.row.is_published ? 'success' : 'warning'">
                    {{ scope.row.is_published ? '已发布' : '未发布' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="view_count" label="浏览" width="80" />
              <el-table-column prop="created_at" label="创建时间" width="180" />
              <el-table-column label="操作" width="200">
                <template #default="scope">
                  <el-button size="small" @click="openDocDialog(scope.row)">编辑</el-button>
                  <el-button size="small" type="danger" @click="deleteDoc(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>

    <!-- 分类对话框 -->
    <el-dialog v-model="categoryDialogVisible" :title="categoryDialogTitle" width="500px">
      <el-form :model="categoryForm" label-width="80px">
        <el-form-item label="名称" required>
          <el-input v-model="categoryForm.name" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="categoryForm.description" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="categoryDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveCategory">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 工具对话框 -->
    <el-dialog v-model="toolDialogVisible" :title="toolDialogTitle" width="600px">
      <el-form :model="toolForm" label-width="100px">
        <el-form-item label="名称" required>
          <el-input v-model="toolForm.name" />
        </el-form-item>
        <el-form-item label="分类" required>
          <el-select v-model="toolForm.category_id" placeholder="请选择分类">
            <el-option
              v-for="cat in categoryList"
              :key="cat.id"
              :label="cat.name"
              :value="cat.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="toolForm.description" type="textarea" :rows="3" />
        </el-form-item>
        <el-form-item label="类型">
          <el-radio-group v-model="toolForm.tool_type">
            <el-radio label="internal">自建工具</el-radio>
            <el-radio label="external">外链工具</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="toolForm.tool_type === 'external'" label="外链地址" required>
          <el-input v-model="toolForm.url" placeholder="https://..." />
        </el-form-item>
        <el-form-item v-else label="内部路径">
          <el-input v-model="toolForm.internal_path" placeholder="/tool/..." />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="toolDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveTool">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 文件编辑对话框 -->
    <el-dialog v-model="editDialogVisible" title="编辑文件" width="800px">
      <el-form label-width="80px">
        <el-form-item label="文件名">
          <el-input v-model="editFilename" placeholder="可编辑文件名" />
          <div style="font-size: 12px; color: #999; margin-top: 5px;">
            修改文件名将重命名文件（仅限可编辑文件类型）
          </div>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            v-model="editContent"
            type="textarea"
            :rows="20"
            placeholder="文件内容..."
            style="font-family: monospace;"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveFileContent">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 文件下载二维码对话框 -->
    <el-dialog v-model="qrDialogVisible" title="文件下载二维码" width="380px" class="qr-dialog">
      <div class="qr-content">
        <div class="qr-filename" :title="qrFile?.name || ''">{{ qrFile?.name }}</div>
        <div class="qr-box" v-loading="qrLoading">
          <img v-if="qrDataUrl" :src="qrDataUrl" alt="文件下载二维码" />
          <div v-else-if="!qrLoading" class="qr-failed">二维码生成失败</div>
        </div>
        <p v-if="qrIsLocalhost" class="qr-warn">当前为本机地址，手机无法访问，请改用域名访问后台后再扫码</p>
        <p v-else class="qr-tip">手机扫码即可自动下载该文件</p>
        <el-input :model-value="qrDownloadUrl" readonly size="small">
          <template #append>
            <el-button @click="copyQrLink">复制</el-button>
          </template>
        </el-input>
      </div>
    </el-dialog>

    <!-- 文档编辑对话框 -->
    <el-dialog v-model="docDialogVisible" :title="docDialogTitle" width="1100px">
      <el-form :model="docForm" label-width="100px">
        <el-form-item label="标题">
          <el-input v-model="docForm.title" placeholder="留空则自动使用文件名（不含后缀）" />
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="docForm.description" type="textarea" :rows="3" placeholder="文档描述" />
        </el-form-item>
        <el-form-item label="内容" v-if="docForm.id" class="md-editor-form-item">
          <div class="md-editor-container">
            <div class="md-editor-pane">
              <div class="md-editor-pane-header">Markdown 源码</div>
              <textarea
                v-model="docForm.content"
                class="md-editor-textarea"
                placeholder="在此编辑 Markdown 内容..."
              ></textarea>
            </div>
            <div class="md-preview-pane">
              <div class="md-preview-pane-header">预览</div>
              <div class="md-preview-body markdown-body" v-html="mdPreview"></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="分类">
          <el-input v-model="docForm.category" placeholder="例如：技术、指南、API" />
        </el-form-item>
        <el-form-item label="发布状态">
          <el-switch v-model="docForm.is_published" active-text="已发布" inactive-text="未发布" />
        </el-form-item>
        <el-form-item label="文件" v-if="!docForm.id">
          <el-upload
            ref="docUploadRef"
            class="upload-demo"
            :auto-upload="false"
            :show-file-list="true"
            :on-change="handleDocFileChange"
            :before-upload="beforeDocUpload"
          >
            <el-button type="primary">选择文件</el-button>
            <template #tip>
              <div class="el-upload__tip">
                仅支持 Markdown (.md) 文件，最大 16 MB
              </div>
            </template>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="docDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveDoc">保存</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import type { UploadInstance, UploadRequestOptions } from 'element-plus'
import { UploadFilled, Rank } from '@element-plus/icons-vue'
import Sortable from 'sortablejs'
import QRCode from 'qrcode'
import { renderDocHtml } from '@/composables/useMarkdownDoc'
import '@/styles/markdown-doc.css'
import {
  getCategories,
  createCategory,
  updateCategory,
  updateCategoriesOrder,
  deleteCategory as deleteCategoryApi
} from '@/api/categories'
import {
  getTools,
  createTool,
  updateTool,
  updateToolsOrder,
  deleteTool as deleteToolApi
} from '@/api/tools'
import { getAdminStats, changePassword } from '@/api/admin'
import {
  uploadFile,
  getFiles,
  deleteFile as deleteFileApi,
  getFileContent,
  updateFileContent,
  renameFile
} from '@/api/uploads'
import {
  getDocs,
  uploadDoc,
  updateDoc,
  updateDocContent,
  deleteDoc as deleteDocApi,
  updateDocsOrder,
  getDocContent
} from '@/api/docs'
import type { Ref } from 'vue'
import type { CategoryListItem } from '@/types/category'
import type { Tool } from '@/types/tool'
import type { DocumentItem } from '@/types/document'
import type { UploadFileItem } from '@/types/upload'
import type { AdminStats } from '@/types/admin'

interface CategoryForm {
  id: number | null
  name: string
  description: string
}

interface ToolForm {
  id: number | null
  name: string
  category_id: number | null
  description: string
  tool_type: string
  url: string
  internal_path: string
}

interface DocForm {
  id: number | null
  title: string
  description: string
  category: string
  is_published: boolean
  file: File | null
  content: string
}

// 支持 ?tab= 定位页签（文档页的"编辑/删除"跳转过来时携带）
const route = useRoute()
const activeTab = ref(
  typeof route.query.tab === 'string' && route.query.tab ? route.query.tab : 'categories'
)
const categoryList = ref<CategoryListItem[]>([])
const toolList = ref<Tool[]>([])
const stats = ref<AdminStats>({
  category_count: 0,
  tool_count: 0,
  external_count: 0,
  internal_count: 0,
  user_count: 0
})
const fileList = ref<UploadFileItem[]>([])
const docList = ref<DocumentItem[]>([])

const categoryTableRef = ref()
const toolTableRef = ref()
const docTableRef = ref()

function initSortable(
  tableRef: Ref<any>,
  list: Ref<Array<{ id: number }>>,
  saveOrder: (ids: number[]) => Promise<unknown>,
  reload?: () => Promise<void>
) {
  const tableEl = tableRef.value?.$el
  const tbody = tableEl?.querySelector('.el-table__body-wrapper tbody')
  if (!tbody || (tbody as any).__sortableInstance) return
  ;(tbody as any).__sortableInstance = Sortable.create(tbody, {
    handle: '.drag-handle',
    animation: 150,
    ghostClass: 'sortable-ghost',
    onEnd: async ({ oldIndex, newIndex }: { oldIndex?: number; newIndex?: number }) => {
      if (oldIndex === undefined || newIndex === undefined || oldIndex === newIndex) return
      const snapshot = list.value.slice()
      const moved = list.value.splice(oldIndex, 1)[0]
      list.value.splice(newIndex, 0, moved)
      try {
        await saveOrder(list.value.map((item) => item.id))
        ElMessage.success('排序已保存，首页已同步')
      } catch (error) {
        ElMessage.error('排序保存失败：' + (error as Error).message)
        list.value.splice(0, list.value.length, ...snapshot)
        if (reload) await reload()
      }
    }
  })
}

const passwordForm = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: ''
})

const categoryDialogVisible = ref(false)
const categoryForm = ref<CategoryForm>({ id: null, name: '', description: '' })
const categoryDialogTitle = computed(() => (categoryForm.value.id ? '编辑分类' : '添加分类'))

const toolDialogVisible = ref(false)
const toolForm = ref<ToolForm>({
  id: null,
  name: '',
  category_id: null,
  description: '',
  tool_type: 'internal',
  url: '',
  internal_path: ''
})
const toolDialogTitle = computed(() => (toolForm.value.id ? '编辑工具' : '添加工具'))

const editDialogVisible = ref(false)
const editContent = ref('')
const editFilename = ref('')
const originalFilename = ref('')

// 文件下载二维码：按下载地址缓存，上传成功后预生成，点击按钮即可秒开
const qrDialogVisible = ref(false)
const qrFile = ref<UploadFileItem | null>(null)
const qrDataUrl = ref('')
const qrLoading = ref(false)
const qrCache = new Map<string, string>()

const qrDownloadUrl = computed(() => (qrFile.value ? buildDownloadUrl(qrFile.value.name) : ''))
// 本机地址生成二维码手机无法访问，给出提示避免误用
const qrIsLocalhost = computed(() =>
  ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname)
)

const docDialogVisible = ref(false)
const docUploadRef = ref<UploadInstance>()
const docForm = ref<DocForm>({
  id: null,
  title: '',
  description: '',
  category: '',
  is_published: true,
  file: null,
  content: ''
})
const docDialogTitle = computed(() => (docForm.value.id ? '编辑文档' : '上传文档'))

const mdPreview = computed(() => {
  if (!docForm.value.content) return '<p style="color: #999;">在左侧输入 Markdown 内容即可预览</p>'
  // 复用文档模块的渲染逻辑（含 DOMPurify 消毒与中文友好锚点）
  return renderDocHtml(docForm.value.content)
})

onMounted(async () => {
  await loadCategories()
  await loadTools()
  await loadStats()
})

async function loadCategories() {
  try {
    categoryList.value = await getCategories({ include_inactive: true })
  } catch (error) {
    console.error('Failed to load categories:', error)
  }
  await nextTick()
  initSortable(categoryTableRef, categoryList, updateCategoriesOrder, loadCategories)
}

async function loadTools() {
  try {
    toolList.value = await getTools({ include_inactive: true })
  } catch (error) {
    console.error('Failed to load tools:', error)
  }
  await nextTick()
  initSortable(toolTableRef, toolList, updateToolsOrder, loadTools)
}

async function loadStats() {
  try {
    stats.value = await getAdminStats()
  } catch (error) {
    console.error('Failed to load stats:', error)
  }
}

function openCategoryDialog(category: CategoryListItem | null) {
  if (category) {
    categoryForm.value = {
      id: category.id,
      name: category.name,
      description: category.description || ''
    }
  } else {
    categoryForm.value = { id: null, name: '', description: '' }
  }
  categoryDialogVisible.value = true
}

function openToolDialog(tool: Tool | null) {
  if (tool) {
    toolForm.value = {
      id: tool.id,
      name: tool.name,
      category_id: tool.category_id ?? null,
      description: tool.description || '',
      tool_type: tool.tool_type === 'external' ? 'external' : 'internal',
      url: tool.url || '',
      internal_path: tool.internal_path || ''
    }
  } else {
    toolForm.value = {
      id: null,
      name: '',
      category_id: categoryList.value[0]?.id ?? null,
      description: '',
      tool_type: 'internal',
      url: '',
      internal_path: ''
    }
  }
  toolDialogVisible.value = true
}

async function saveCategory() {
  try {
    if (categoryForm.value.id) {
      await updateCategory(categoryForm.value.id, {
        name: categoryForm.value.name,
        description: categoryForm.value.description
      })
      ElMessage.success('分类更新成功')
    } else {
      await createCategory({
        name: categoryForm.value.name,
        description: categoryForm.value.description
      })
      ElMessage.success('分类添加成功')
    }
    categoryDialogVisible.value = false
    await loadCategories()
  } catch (error) {
    ElMessage.error('操作失败：' + (error as Error).message)
  }
}

async function saveTool() {
  try {
    const payload = {
      name: toolForm.value.name,
      category_id: toolForm.value.category_id,
      description: toolForm.value.description,
      tool_type: toolForm.value.tool_type,
      url: toolForm.value.tool_type === 'external' ? toolForm.value.url : '',
      internal_path: toolForm.value.tool_type === 'internal' ? toolForm.value.internal_path : ''
    }
    if (toolForm.value.id) {
      await updateTool(toolForm.value.id, payload)
      ElMessage.success('工具更新成功')
    } else {
      await createTool(payload)
      ElMessage.success('工具添加成功')
    }
    toolDialogVisible.value = false
    await loadTools()
  } catch (error) {
    ElMessage.error('操作失败：' + (error as Error).message)
  }
}

async function deleteCategory(id: number) {
  try {
    await ElMessageBox.confirm('确定删除该分类吗？', '警告', { type: 'warning' })
    await deleteCategoryApi(id)
    ElMessage.success('删除成功')
    await loadCategories()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败：' + (error as Error).message)
    }
  }
}

async function deleteTool(id: number) {
  try {
    await ElMessageBox.confirm('确定删除该工具吗？', '警告', { type: 'warning' })
    await deleteToolApi(id)
    ElMessage.success('删除成功')
    await loadTools()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败：' + (error as Error).message)
    }
  }
}

async function loadFiles() {
  try {
    fileList.value = await getFiles()
  } catch (error) {
    console.error('Failed to load files:', error)
  }
}

interface UploadTask {
  uid: number
  name: string
  size: number
  percent: number
  status: 'uploading' | 'success' | 'error'
  message?: string
}

// 上传队列：用 http-request 自定义上传，才能拿到真实进度并即时刷新列表
const uploadQueue = ref<UploadTask[]>([])

async function handleUploadRequest(options: UploadRequestOptions) {
  const file = options.file
  const task: UploadTask = {
    uid: Date.now() + Math.random(),
    name: file.name,
    size: file.size,
    percent: 0,
    status: 'uploading'
  }
  uploadQueue.value.push(task)
  try {
    const result = await uploadFile(file, (percent) => {
      task.percent = percent
    })
    task.percent = 100
    task.status = 'success'
    options.onSuccess?.(result)
    ElMessage.success(`${file.name} 上传成功`)
    // 上传成功即预生成下载二维码（存缓存），后续点击"二维码"秒开
    generateQr(buildDownloadUrl(result.stored_name || result.id)).catch((error) => {
      console.error('Failed to pre-generate QR code:', error)
    })
    // 每个文件上传成功立即刷新列表，避免需要手动刷新页面才能看到
    await loadFiles()
  } catch (error) {
    task.status = 'error'
    task.message = error instanceof Error ? error.message : '上传失败'
    // el-upload 的错误回调期望 UploadAjaxError，这里放宽类型
    options.onError?.(error as never)
    ElMessage.error(`${file.name} 上传失败：${task.message}`)
  }
}

function clearFinishedUploads() {
  uploadQueue.value = uploadQueue.value.filter((task) => task.status === 'uploading')
}

function beforeUpload(file: File) {
  const isLt16M = file.size / 1024 / 1024 < 16
  if (!isLt16M) {
    ElMessage.error('文件大小不能超过 16 MB')
    return false
  }
  return true
}

function formatFileSize(bytes: number) {
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

/** 生成直链下载地址（download=1 让后端以附件形式返回，扫码即下载）。 */
function buildDownloadUrl(filename: string): string {
  const path = `/api/uploads/${encodeURIComponent(filename)}?download=1`
  return window.location.origin + path
}

/** 生成二维码（带缓存）；同一文件重复点击无需重新计算。 */
async function generateQr(url: string): Promise<string> {
  const cached = qrCache.get(url)
  if (cached) return cached
  const dataUrl = await QRCode.toDataURL(url, {
    width: 280,
    margin: 1,
    errorCorrectionLevel: 'M',
    color: { dark: '#303133', light: '#ffffff' }
  })
  qrCache.set(url, dataUrl)
  return dataUrl
}

async function openQrDialog(file: UploadFileItem) {
  qrFile.value = file
  qrDataUrl.value = ''
  qrDialogVisible.value = true
  qrLoading.value = true
  try {
    qrDataUrl.value = await generateQr(buildDownloadUrl(file.name))
  } catch (error) {
    console.error('Failed to generate QR code:', error)
    ElMessage.error('二维码生成失败')
  } finally {
    qrLoading.value = false
  }
}

function copyQrLink() {
  if (qrDownloadUrl.value) fallbackCopy(qrDownloadUrl.value)
}

function copyLink(url: string) {
  let fullUrl = url
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    fullUrl = window.location.origin + url
  }
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(fullUrl)
      .then(() => ElMessage.success('完整链接已复制到剪贴板'))
      .catch(() => fallbackCopy(fullUrl))
  } else {
    fallbackCopy(fullUrl)
  }
}

function fallbackCopy(text: string) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  textArea.style.left = '-999999px'
  textArea.style.top = '-999999px'
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  try {
    const successful = document.execCommand('copy')
    if (successful) ElMessage.success('完整链接已复制到剪贴板')
    else ElMessage.error('复制失败，请手动复制')
  } catch (err) {
    ElMessage.error('复制失败，请手动复制：' + text)
  }
  document.body.removeChild(textArea)
}

async function deleteFile(filename: string) {
  try {
    await ElMessageBox.confirm('确定删除该文件吗？', '警告', { type: 'warning' })
    await deleteFileApi(filename)
    ElMessage.success('删除成功')
    loadFiles()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败：' + (error as Error).message)
    }
  }
}

function isEditableFile(filename: string) {
  const editableExtensions = [
    'txt', 'html', 'htm', 'css', 'js', 'json', 'md', 'xml', 'csv',
    'py', 'java', 'c', 'cpp', 'h', 'hpp', 'go', 'rs', 'php', 'rb', 'pl', 'sh', 'bat',
    'yml', 'yaml', 'toml', 'ini', 'cfg', 'conf', 'properties',
    'sql', 'log', 'tex', 'rst', 'markdown', 'asciidoc', 'adoc',
    'vue', 'ts', 'tsx', 'jsx', 'scss', 'sass', 'less', 'styl',
    'env', 'editorconfig', 'json5', 'jsonl', 'ndjson', 'graphql', 'gql',
    'ipynb', 'rmd', 'swift', 'kt', 'kts', 'scala', 'dart',
    'lua', 'r', 'm', 'mat', 'ps1', 'psm1', 'vbs', 'asm',
    'clj', 'cljs', 'edn', 'coffee', 'groovy',
    'ex', 'exs', 'erl', 'hrl', 'ml', 'mli', 'fs', 'fsx',
    'vb', 'cs', 'proto', 'thrift', 'avdl', 'xsd', 'xsl', 'xslt',
    'config', 'manifest', 'lock', 'sum', 'mod', 'gradle', 'pom',
    'makefile', 'cmake', 'test', 'spec', 'schema', 'sln', 'csproj'
  ]
  const ext = filename.split('.').pop()?.toLowerCase() || ''
  return editableExtensions.includes(ext)
}

async function openEditDialog(file: UploadFileItem) {
  originalFilename.value = file.name
  editFilename.value = file.name
  editContent.value = ''
  editDialogVisible.value = true
  try {
    const data = await getFileContent(file.name)
    editContent.value = data.content
  } catch (error) {
    console.error('Failed to load file content:', error)
    ElMessage.error('加载文件内容失败：' + (error as Error).message)
  }
}

async function saveFileContent() {
  if (!editFilename.value) return
  try {
    if (originalFilename.value !== editFilename.value) {
      await renameFile(originalFilename.value, editFilename.value)
      originalFilename.value = editFilename.value
    }
    await updateFileContent(editFilename.value, editContent.value)
    ElMessage.success('文件保存成功')
    editDialogVisible.value = false
    loadFiles()
  } catch (error) {
    console.error('Failed to save file content:', error)
    ElMessage.error('保存文件失败：' + (error as Error).message)
  }
}

async function submitPasswordChange() {
  const { oldPassword, newPassword, confirmPassword } = passwordForm.value
  if (!oldPassword || !newPassword || !confirmPassword) {
    ElMessage.warning('请填写所有字段')
    return
  }
  if (newPassword !== confirmPassword) {
    ElMessage.warning('新密码与确认密码不一致')
    return
  }
  if (newPassword.length < 6) {
    ElMessage.warning('新密码长度至少6位')
    return
  }
  try {
    await changePassword({ old_password: oldPassword, new_password: newPassword })
    ElMessage.success('密码修改成功')
    resetPasswordForm()
  } catch (error) {
    const message =
      (error as { response?: { data?: { error?: string } } }).response?.data?.error ||
      (error as Error).message
    ElMessage.error('密码修改失败：' + message)
  }
}

function resetPasswordForm() {
  passwordForm.value = { oldPassword: '', newPassword: '', confirmPassword: '' }
}

async function loadDocs() {
  try {
    docList.value = await getDocs({ published: 'false' })
  } catch (error) {
    console.error('Failed to load docs:', error)
  }
  await nextTick()
  initSortable(docTableRef, docList, updateDocsOrder, loadDocs)
}

async function openDocDialog(doc: DocumentItem | null) {
  if (doc) {
    try {
      const data = await getDocContent(doc.id)
      docForm.value = {
        id: doc.id,
        title: doc.title,
        description: doc.description || '',
        category: doc.category || '',
        is_published: !!doc.is_published,
        file: null,
        content: data.content || ''
      }
    } catch (error) {
      console.error('Failed to load document content:', error)
      ElMessage.warning('加载文档内容失败，仅可编辑元数据')
      docForm.value = {
        id: doc.id,
        title: doc.title,
        description: doc.description || '',
        category: doc.category || '',
        is_published: !!doc.is_published,
        file: null,
        content: ''
      }
    }
  } else {
    docForm.value = {
      id: null,
      title: '',
      description: '',
      category: '',
      is_published: true,
      file: null,
      content: ''
    }
    // 清空上传组件残留的文件列表，避免再次打开时显示上一次选中的文件
    docUploadRef.value?.clearFiles()
  }
  docDialogVisible.value = true
}

/** 去掉最后一个扩展名，得到文件名主体（例如 guide.v1.md -> guide.v1） */
function titleFromFilename(name: string): string {
  return name.replace(/\.[^/.]+$/, '') || name
}

function handleDocFileChange(file: any) {
  docForm.value.file = file.raw as File
  // 新上传文档时自动用文件名填充标题，用户仍可手动修改；已手动填写则不覆盖
  if (!docForm.value.id && docForm.value.file && !docForm.value.title.trim()) {
    docForm.value.title = titleFromFilename(docForm.value.file.name)
  }
}

function beforeDocUpload(file: File) {
  const isMd = file.name.endsWith('.md')
  const isLt16M = file.size / 1024 / 1024 < 16
  if (!isMd) {
    ElMessage.error('只能上传 Markdown (.md) 文件')
    return false
  }
  if (!isLt16M) {
    ElMessage.error('文件大小不能超过 16 MB')
    return false
  }
  return true
}

async function saveDoc() {
  try {
    if (docForm.value.id) {
      await updateDoc(docForm.value.id, {
        title: docForm.value.title,
        description: docForm.value.description,
        category: docForm.value.category,
        is_published: docForm.value.is_published
      })
      if (docForm.value.content !== undefined) {
        await updateDocContent(docForm.value.id, docForm.value.content)
      }
      ElMessage.success('文档更新成功')
    } else {
      if (!docForm.value.file) {
        ElMessage.error('请选择要上传的文件')
        return
      }
      await uploadDoc(docForm.value.file, {
        title: docForm.value.title.trim(),
        description: docForm.value.description,
        category: docForm.value.category,
        is_published: docForm.value.is_published
      })
      ElMessage.success('文档上传成功')
    }
    docDialogVisible.value = false
    await loadDocs()
  } catch (error) {
    ElMessage.error('操作失败：' + (error as Error).message)
  }
}

async function deleteDoc(id: number) {
  try {
    await ElMessageBox.confirm('确定删除该文档吗？', '警告', { type: 'warning' })
    await deleteDocApi(id)
    ElMessage.success('删除成功')
    await loadDocs()
  } catch (error) {
    if (error !== 'cancel') {
      ElMessage.error('删除失败：' + (error as Error).message)
    }
  }
}

watch(activeTab, (newTab) => {
  if (newTab === 'files') {
    loadFiles()
  }
  if (newTab === 'docs') {
    loadDocs()
  }
})
</script>


<style scoped>
.admin {
  padding: 20px;
}
.drag-handle {
  cursor: grab;
  color: #909399;
  font-size: 16px;
}
.drag-handle:active {
  cursor: grabbing;
}
.sortable-ghost {
  opacity: 0.4;
  background-color: var(--el-color-primary-light-9) !important;
}
.stat-number {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  color: var(--el-color-primary);
}
.card-header {
  font-weight: bold;
}

/* 文件下载二维码弹窗 */
.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.qr-filename {
  max-width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.qr-box {
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #fff;
}
.qr-box img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.qr-failed {
  font-size: 13px;
  color: #909399;
}
.qr-tip {
  margin: 0;
  font-size: 13px;
  color: #909399;
}
.qr-warn {
  margin: 0;
  font-size: 13px;
  color: #e6a23c;
  text-align: center;
}

/* 上传队列（文件部署） */
.upload-queue {
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafafa;
}
.upload-queue-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}
.upload-queue-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 0;
  font-size: 13px;
  color: #606266;
}
.upload-queue-item .uq-name {
  flex: 0 0 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-queue-item .uq-progress {
  flex: 1;
  min-width: 120px;
}
.upload-queue-item .uq-size {
  flex: 0 0 80px;
  color: #909399;
  text-align: right;
}
.upload-queue-item .uq-state {
  flex: 0 0 90px;
  text-align: right;
}
.upload-queue-item .uq-state.success {
  color: #67c23a;
}
.upload-queue-item .uq-state.error {
  color: #f56c6c;
}

/* MD编辑器分屏布局 */
.md-editor-form-item :deep(.el-form-item__content) {
  display: block;
}

.md-editor-container {
  display: flex;
  gap: 12px;
  height: 520px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  overflow: hidden;
}

.md-editor-pane,
.md-preview-pane {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.md-editor-pane {
  border-right: 1px solid #e4e7ed;
}

.md-editor-pane-header,
.md-preview-pane-header {
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  background: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  flex-shrink: 0;
}

.md-editor-textarea {
  flex: 1;
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  padding: 14px;
  font-family: 'Cascadia Code', 'Fira Code', 'JetBrains Mono', 'Source Code Pro', Consolas, monospace;
  font-size: 14px;
  line-height: 1.7;
  color: #303133;
  background: #fafafa;
}

.md-editor-textarea:focus {
  background: #fff;
}

.md-preview-body {
  flex: 1;
  overflow-y: auto;
  padding: 14px 18px;
  background: #fff;
}

/* markdown 排版样式统一走 styles/markdown-doc.css（.markdown-body） */

/* 移动端：MD 编辑器分屏改为上下堆叠 */
@media (max-width: 768px) {
  .md-editor-container {
    flex-direction: column;
    height: 420px;
  }
  .md-editor-pane {
    border-right: none;
    border-bottom: 1px solid #e4e7ed;
  }
  .stat-number {
    font-size: 28px;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
}
</style>